import { useSelector } from 'react-redux';
import { thoughtspot } from 'config';
import { initialiseThoughtspot } from 'utils/thoughtspotInit';
import { cancelFunctions } from 'utils/cancelFunctions';
import { Store } from 'components/common/types/Store.types';
import LiveboardVisuals from 'components/common/LiveboardVisuals';
import { getIsReseller } from 'store/publisher/selectors';
import {
  thoughtspotLiveboardStyles,
  labsReportVisibleActions,
  TABS_STYLES,
  filterByAssetOwner,
  hiddenAssetOwnerThoughtspotLiveboardStyles,
  filterByCampaignOwner,
} from '../LabsReportDropdown/utils';

const ProofOfPlay: React.FC = () => {
  const { localeCode, marketId } = useSelector((state: Store) => state.publisher.configuration);
  const isReseller = useSelector(getIsReseller);

  initialiseThoughtspot(localeCode, cancelFunctions);

  const proofOfPlayLiveboardId = isReseller
    ? thoughtspot.resellerProofOfPlayLiveboardId
    : thoughtspot.proofOfPlayLiveboardId;

  return (
    <div className={TABS_STYLES}>
      <LiveboardVisuals
        liveboardId={proofOfPlayLiveboardId}
        customizations={isReseller ? thoughtspotLiveboardStyles : hiddenAssetOwnerThoughtspotLiveboardStyles}
        visibleActions={labsReportVisibleActions}
        filterByOptions={[isReseller ? filterByCampaignOwner(marketId) : filterByAssetOwner(marketId)]}
      />
    </div>
  );
};

export default ProofOfPlay;
